import React from 'react';
import { Trash2, HardHat, Home, Building2, ArrowRight } from 'lucide-react';
const services = [{
  title: 'Junk Removal',
  description: 'Residential and commercial junk hauling. We clear out the clutter with speed and efficiency.',
  icon: Trash2
}, {
  title: 'Construction Cleanup',
  description: 'Post-build site clearing. We handle the debris so you can focus on the final touches.',
  icon: HardHat
}, {
  title: 'Estate Cleanouts',
  description: 'Respectful and thorough property clearing for estates, foreclosures, and evictions.',
  icon: Home
}, {
  title: 'Commercial Cleanup',
  description: 'Heavy-duty clearing for offices, retail spaces, and industrial sites.',
  icon: Building2
}];
export function Services() {
  return <section id="services" className="py-24 bg-card relative" data-id="element-183">
      <div className="container mx-auto px-4" data-id="element-184">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16" data-id="element-185">
          <div className="max-w-2xl" data-id="element-186">
            <h2 className="text-primary font-bold tracking-widest uppercase text-sm mb-3 flex items-center gap-2" data-id="element-187">
              <span className="w-8 h-[2px] bg-primary" data-id="element-188"></span>
              Core Capabilities
            </h2>
            <h3 className="font-heading font-black text-4xl md:text-5xl uppercase tracking-tight" data-id="element-189">
              Tactical Cleanup Solutions
            </h3>
          </div>
          <p className="text-muted-foreground max-w-md font-medium" data-id="element-190">
            No job is too tough. We deploy specialized teams to handle debris,
            junk, and site clearing with military-grade efficiency.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-191">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} className="group relative bg-background border border-border p-8 rounded-lg hover:border-primary/50 transition-colors overflow-hidden" data-id="element-192">
                <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity transform group-hover:scale-110 duration-500" data-id="element-193">
                  <Icon className="w-32 h-32" data-id="element-194" />
                </div>

                <div className="relative z-10" data-id="element-195">
                  <div className="w-12 h-12 bg-secondary rounded flex items-center justify-center mb-6 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors" data-id="element-196">
                    <Icon className="w-6 h-6" data-id="element-197" />
                  </div>
                  <h4 className="font-heading font-bold text-xl uppercase tracking-wide mb-3" data-id="element-198">
                    {service.title}
                  </h4>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-6" data-id="element-199">
                    {service.description}
                  </p>
                  <a href="#contact" className="inline-flex items-center text-sm font-bold uppercase tracking-wider text-primary hover:text-foreground transition-colors" data-id="element-200">
                    Learn More <ArrowRight className="ml-2 w-4 h-4" data-id="element-201" />
                  </a>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}